import { Plus, Copy, Trash2, ChevronLeft, ChevronRight } from 'lucide-react';
import { MenuCanvas } from './MenuCanvas';

const THUMB_H = 56;

export const PageStrip = ({ pages, activePageId, canvas, customFonts, onSelect, onAdd, onDuplicate, onDelete, onMove }) => {
  const activeIdx = pages.findIndex((p) => p.id === activePageId);
  const thumbW = Math.max(22, Math.round(THUMB_H * (canvas.width / canvas.height)));
  return (
    <div className="pb-safe flex items-center gap-2 border-t border-white/[0.06] bg-[#0f0f11] px-2 py-2" data-testid="page-strip">
      <div className="flex shrink-0 items-center gap-1 pr-1">
        <span className="hidden px-1 text-[11px] font-semibold uppercase tracking-widest text-[#71717a] sm:inline">Pages</span>
        <button type="button" title="Move page left" data-testid="move-page-left-btn" onClick={() => onMove(-1)} disabled={activeIdx <= 0}
          className="flex h-8 w-8 items-center justify-center rounded-lg text-[#a1a1aa] hover:bg-white/[0.06] hover:text-white disabled:opacity-30"><ChevronLeft className="h-4 w-4" /></button>
        <button type="button" title="Move page right" data-testid="move-page-right-btn" onClick={() => onMove(1)} disabled={activeIdx >= pages.length - 1}
          className="flex h-8 w-8 items-center justify-center rounded-lg text-[#a1a1aa] hover:bg-white/[0.06] hover:text-white disabled:opacity-30"><ChevronRight className="h-4 w-4" /></button>
        <button type="button" title="Duplicate page" data-testid="duplicate-page-btn" onClick={onDuplicate}
          className="flex h-8 w-8 items-center justify-center rounded-lg text-[#a1a1aa] hover:bg-white/[0.06] hover:text-white"><Copy className="h-4 w-4" /></button>
        <button type="button" title="Delete page" data-testid="delete-page-btn" onClick={onDelete} disabled={pages.length <= 1}
          className="flex h-8 w-8 items-center justify-center rounded-lg text-[#a1a1aa] hover:bg-white/[0.06] hover:text-[#f43f5e] disabled:opacity-30"><Trash2 className="h-4 w-4" /></button>
      </div>
      <span className="h-8 w-px shrink-0 bg-white/[0.08]" />
      <div className="flex min-w-0 flex-1 items-center gap-2 overflow-x-auto py-1">
        {pages.map((p, i) => {
          const active = p.id === activePageId;
          return (
            <button
              key={p.id}
              type="button"
              onClick={() => onSelect(p.id)}
              data-testid={`page-thumb-${p.id}`}
              title={`Page ${i + 1}`}
              className={`relative shrink-0 overflow-hidden rounded-md border transition-colors ${active ? 'border-[#A855F7] ring-1 ring-[#A855F7]' : 'border-white/[0.1] hover:border-white/[0.25]'}`}
              style={{ width: thumbW, height: THUMB_H }}
            >
              <MenuCanvas menu={{ canvas }} elements={p.elements} width={thumbW} customFonts={customFonts} />
              <span className={`absolute bottom-0 right-0 rounded-tl px-1 text-[9px] font-bold leading-tight ${active ? 'bg-[#A855F7] text-white' : 'bg-black/70 text-white/80'}`}>{i + 1}</span>
            </button>
          );
        })}
        <button
          type="button"
          onClick={onAdd}
          data-testid="add-page-btn"
          title="Add page"
          className="flex shrink-0 items-center justify-center rounded-md border border-dashed border-white/[0.2] text-[#a1a1aa] hover:border-[#EAB308] hover:text-[#EAB308]"
          style={{ width: thumbW, height: THUMB_H }}
        >
          <Plus className="h-5 w-5" />
        </button>
      </div>
    </div>
  );
};
